import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {creativeTemplatesApi} from '../../../../creativeTemplates.api';
import {CreativeTemplatesManagerAgentToolName} from '../creativeTemplatesManagetAgent.enums';

const inputSchema = z.object({
  templateId: z.number(),
  includeFormats: z.boolean().describe('Ask user, set to true by default'),
});

function duplicateCreativeTemplateTool() {
  async function execute({
    input: {templateId, includeFormats},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    try {
      const duplicatedTemplateId = await creativeTemplatesApi.duplicateTemplateToAgency({
        templateId,
        includeFormats,
      });

      routingService.goTo({
        url: Routes.TemplateWorkflow,
        pathParams: {templateId: duplicatedTemplateId},
      });

      return toolResult(
        JSON.stringify({
          message: 'Template duplicated successfully',
          duplicatedTemplateId,
          originalTemplateId: templateId,
        }),
      );
    } catch (error) {
      return toolResult(
        JSON.stringify({
          error: `Failed to duplicate template: ${error instanceof Error ? error.message : 'Unknown error'}`,
          templateId,
        }),
      );
    }
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.DuplicateCreativeTemplate,
    description: 'Duplicate an existing creative template',
    displayName: 'Duplicating creative template',
    inputSchema,
    execute,
  });
}

export default duplicateCreativeTemplateTool;
